module.exports = __webpack_public_path__ + "img/icon丰富易⽤的 可视化平台.ad8e9823.png";